import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import ren1 from '../assets/photos/energy_solutions/1.jpg';
import ren2 from '../assets/photos/energy_solutions/2.jpg';
import ren3 from '../assets/photos/energy_solutions/3.jpg';
import ren4 from '../assets/photos/energy_solutions/4.jpg';
import ren5 from '../assets/photos/energy_solutions/5.jpg';
import ren6 from '../assets/photos/energy_solutions/6.jpg';
import ren7 from '../assets/photos/energy_solutions/7.jpg';
import ren8 from '../assets/photos/energy_solutions/8.jpg';
import ren9 from '../assets/photos/energy_solutions/9.jpg';
import ren10 from '../assets/photos/energy_solutions/10.jpg';



import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											RENEWABLE ENERGY SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={energ_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									As a leading provider of renewable energy solutions, we take pride in offering a comprehensive range of products and services tailored to meet the evolving needs of our clients. At our company, we are committed to driving the transition towards a sustainable energy future by delivering high-quality renewable energy solutions that empower individuals, businesses, and communities to harness the power of clean, renewable sources.
								</h6>

								<HorizontalImageStrip
									images={[ren1, ren2, ren3]}
								/>
							</div>

							
							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SOLAR POWER ENERGY SYSTEMS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren2}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide a wide range of solar energy systems, including photovoltaic (PV) panels, solar inverters, mounting structures, and monitoring solutions. Our solar power solutions are designed to harness the abundant energy of the sun and convert it into clean electricity for a variety of applications, including residential, commercial, and industrial use. Whether you’re looking to reduce your carbon footprint, lower your energy bills, or achieve energy independence, our solar power energy solutions are tailored to meet your specific needs.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									WIND ENERGY SYSTEMS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren3}
								/>

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our wind energy offerings include state-of-the-art wind turbines, wind measurement and assessment services, and wind farm development solutions. We harness the power of wind to generate clean, renewable electricity, providing our clients with a reliable and sustainable energy source. With our wind energy solutions, we help businesses and communities capitalize on the immense potential of wind power while reducing their reliance on fossil fuels and mitigating their environmental impact.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									POWER STORAGE EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren2}
								/>

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer power storage equipment solutions to complement our renewable energy offerings. Power storage is a critical component of any renewable energy system, allowing for the efficient capture, storage, and utilization of energy generated from solar, wind, or other renewable sources. Our power storage solutions include battery storage systems, energy management software, and grid-tied storage solutions. Whether you’re looking to store excess energy for use during periods of high demand or to enhance the reliability and resilience of your energy supply, our power storage equipment solutions are designed to meet your needs.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									EV CHARGING STATIONS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren1}
								/>

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Recognizing the surge in electric vehicle (EV) adoption, our company provides advanced EV charging stations suitable for private, commercial, and public use. Our range includes fast, reliable and user-friendly charging solutions that support a variety of EV models. We are committed to accelerating the transition to electric mobility by making EV charging more accessible and convenient, thereby encouraging more individuals and businesses to make the switch.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									CNG (Compressed Natural Gas)
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren9}
								/>

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We are committed to promoting clean and sustainable energy through CNG (Compressed Natural Gas) a renewable alternative to conventional natural gas.
									Products & Services:
									<br/>
									•	CNG Production & Supply: Generation of high-quality Compressed Natural Gas from renewable sources. <br/>
									•	Energy Solutions: Integration of CNG for industrial, commercial, and household energy systems. <br/>
									•	Consulting & Technical Support: Feasibility studies, system design, and operational guidance for sustainable energy projects. <br/>
									<br/><br/>
									CNG helps reduce carbon emissions, lower energy costs, and support environmental conservation aligning your business with a greener future.
								</h6>
							</div>

							

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									FAST REFUELING, ZERO COMPROMISE
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ren10}
								/>

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									In today’s fast-paced world, time is of the essence. JIEZHI TECH’s CNG refueling stations are equipped with advanced technology to ensure a quick and efficient refueling process.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SAFETY, RELIABILITY AND SUSTAINABILITY
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Safety is always our top priority. JIEZHI TECH’s CNG refueling stations strictly adhere to international safety standards, ensuring that every aspect of the operation is under stringent quality control.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SMART MANAGEMENT FOR EFFICIENT OPERATIONS
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									JIEZHI TECH’s CNG refueling stations are not just about hardware; they come with advanced intelligent management systems. Leveraging IoT technology, our stations can monitor equipment status in real-time and provide data analysis and management support.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									CUSTOMIZED SOLUTIONS FOR EVERY NEED
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We understand that each customer has unique requirements, which is why JIEZHI TECH offers customized CNG refueling station solutions. Whether you need a small-scale refueling station or a large-scale CNG mother station, we can design and…
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									THE FUTURE OF FUEL TODAY
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									JIEZHI TECH is dedicated to driving innovation and development in the energy industry. Our CNG refueling stations are an important part of the future energy solution, and we believe that CNG will be one of the main energy sources for future transportation. Through continuous technological innovation and product development, we continue to lead industry standards and provide higher quality services to our customers. As we say, “CNG, The Future of Fuel Today.” We believe that CNG is the best choice for tomorrow.
								</h6>
							</div>

	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}